import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './customer-scheduling.actions';
import { AreaPreference } from '../../modules/report-components/models/areaPreference';
import { ScheduledDate } from '../../modules/report-components/models/scheduledDate';

export interface CustomerSchedulingState {
  preferences: {
    areas: AreaPreference[];
    loading: boolean;
    error: Error;
  };
  scheduledDates: ScheduledDate[];
  requestingAudit: boolean;
  requestedSuccessfully?: boolean;
}

export const initialCustomerSchedulingState: CustomerSchedulingState = {
  preferences: {
    areas: [],
    loading: false,
    error: null,
  },
  scheduledDates: [],
  requestingAudit: false,
};

const reducer = createReducer(
  initialCustomerSchedulingState,
  on(actions.loadAreaPreference, state => ({ ...state, preferences: { ...state.preferences, loading: true } })),
  on(actions.loadAreaPreferenceSuccess, (state, { areaPreference }) => ({
    ...state,
    preferences: { ...state.preferences, loading: false, areas: areaPreference },
  })),
  on(actions.loadAreaPreferenceError, (state, { error }) => ({
    ...state,
    preferences: { ...state.preferences, loading: false, error },
  })),
  on(actions.loadScheduledDatesSuccess, (state, { scheduledDates }) => ({ ...state, scheduledDates })),
  on(actions.loadScheduledDatesError, state => ({ ...state, scheduledDates: [] as ScheduledDate[] })),
  on(actions.requestAudit, state => ({
    ...state,
    requestingAudit: true,
    requestedSuccessfully: false,
  })),
  on(actions.requestAuditSuccess, state => ({
    ...state,
    requestingAudit: false,
    requestedSuccessfully: true,
  })),
  on(actions.requestAuditError, state => ({
    ...state,
    requestingAudit: false,
  })),
  on(actions.clearAcceptedStatus, state => ({ ...state, requestedSuccessfully: false })),
);

export function customerSchedulingReducer(state: CustomerSchedulingState | undefined, action: Action) {
  return reducer(state, action);
}
